import { t } from '@/i18n';
import z from 'zod';
import { FILES_BASE_URL } from './constants';

export const ministryEnum = z.enum([
  'cabinet-secretariat-cabinet-office',
  'fair-trade-commission',
  'national-police-agency',
  'personal-information-protection-commission',
  'casino-regulatory-commission',
  'financial-services-agency',
  'consumer-affairs-agency',
  'children-and-families-agency',
  'digital-agency',
  'reconstruction-agency',
  'ministry-of-internal-affairs-and-communications',
  'ministry-of-justice',
  'ministry-of-foreign-affairs',
  'ministry-of-finance',
  'ministry-of-education-culture-sports-science-and-technology',
  'ministry-of-health-labour-and-welfare',
  'ministry-of-agriculture-forestry-and-fisheries',
  'ministry-of-economy-trade-and-industry',
  'ministry-of-land-infrastructure-and-transport',
  'ministry-of-the-environment',
  'nuclear-regulation-authority',
  'ministry-of-defense',
]);

export type MinistryType = z.infer<typeof ministryEnum>;
export const RSMinistryFileType = z.enum([
  'rsFormat1',
  'rsFormat2',
  'rsFormat3',
  'rsFormat4',
]);
export const LocalGovernmentMinistryFileType = z.enum([
  'ksLocalGovernmentA',
  'ksLocalGovernmentB',
]);

export const MinistryFileTypeEnum = z.enum([
  ...RSMinistryFileType.options,
  'ks',
  ...LocalGovernmentMinistryFileType.options,
  'ksInvestment',
]);

export type MinistryFileType = z.infer<typeof MinistryFileTypeEnum>;
export type SpecificMinistryType = 'cabinet-office' | 'cabinet-secretariat';

export type MinistriesType = {
  key: MinistryType;
  name: string;
  files: {
    specificMinistry?: SpecificMinistryType;
    fileType: z.infer<typeof MinistryFileTypeEnum>;
    fileName: string;
  }[];
};

export const getPublicExportFilesPath = (year: string, key: MinistryType) =>
  `${FILES_BASE_URL}/${year}/${key}/`;

export const addMinistryNamePrefix = (
  str: string,
  specificMinistry: MinistriesType['files'][number]['specificMinistry'],
) => {
  const ministryNames = {
    'cabinet-secretariat': t('ps-ministry-name-cabinet-secretariat'),
    'cabinet-office': t('ps-ministry-name-cabinet-office'),
  };

  return `${specificMinistry ? `${ministryNames[specificMinistry]}_` : ''}${str}`;
};
